





























































































import { Component, Prop, Vue } from 'vue-property-decorator';
import MobileDetect from 'mobile-detect';

import type { Phase } from '@/models/phase';
import type { CompanySetting } from '@/models/companySetting';
import type { Tag } from '@/models/tag';

@Component({
    name: 'FilteringSetting',
})
export default class FilteringSetting extends Vue {
    @Prop() private phases: Phase[];
    @Prop() private selectedPhase: Phase;

    @Prop() private tags: Tag[];
    @Prop() private selectedTag: Tag;
    @Prop() private companySetting: CompanySetting;
    @Prop() private canResetFilter: boolean;
    @Prop() private showOnlyMyLessons: boolean;

    private get isDesktop() {
        const isNotDesktop = window.matchMedia('only screen and (max-width: 1300px)').matches;
        const md = new MobileDetect(window.navigator.userAgent);
        return !(md.mobile() || md.phone() || md.tablet() || isNotDesktop);
    }

    get showOnlyMyLessonsCopy() {
        return this.showOnlyMyLessons;
    }

    // noinspection JSUnusedGlobalSymbols
    set showOnlyMyLessonsCopy(value: boolean) {
        this.$emit('showOnlyMyLessonsChanged', value);
    }

    get showEmptyTopics() {
        return this.$store.getters['knowledge/showEmptyTopics'];
    }

    set showEmptyTopics(value: boolean) {
        this.$store.commit('knowledge/setShowEmptyTopics', value);
    }

    get selectedPhaseCopy() {
        return this.selectedPhase;
    }

    // noinspection JSUnusedGlobalSymbols
    set selectedPhaseCopy(value: Phase) {
        this.$emit('phaseChanged', value);
    }

    get selectedTagCopy() {
        return this.selectedTag;
    }

    // noinspection JSUnusedGlobalSymbols
    set selectedTagCopy(value: Tag) {
        this.$emit('tagChanged', value);
    }
}
